import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import useApi from '../hooks/UseApi';
import Api from '../utils/Api';
import headerSlice, { showNotification } from '../features/common/headerSlice';
import config from '../config/config';
import { toast } from 'react-toastify';


// First, create the thunk
// const fetchUserById = createAsyncThunk(
//   'users/fetchByIdStatus',
//   async (userId: number, thunkAPI) => {
//     const response = await userAPI.fetchById(userId)
//     return response.data
//   },
// )

/*
/// api.js
export const fetchLocations = async (path, page) => {
  return axios({
    method: 'GET',
    url: config.API.BASE_URI + path + '?_page=' + page,
    // url: config.API.BASE_URI + 'users?_page=1',
  }).then(response => response
  ).catch(err => err);
  // const { get, post, updating } = useApi();

  // return get('users', { page: 1 }).then(r => {
  //   console.log(r);
  //   return r.data;
  //   // setData(r.data);
  // })

};


export const post = async (path, data) => {
  return axios({
    method: 'POST',
    url: config.API.BASE_URI + path,
    data: data,
  }).then(response => response.data
  ).catch(err => err);
  // const { get, post, updating } = useApi();

  // return get('users', { page: 1 }).then(r => {
  //   console.log(r);
  //   return r.data;
  //   // setData(r.data);
  // })

};

*/


export const getUsers = createAsyncThunk('users/list', async (data) => {
  if (!(typeof data === 'object' && !Array.isArray(data) && data !== null)) {
    data = { page: data };
  }
  const page = data.page ? '?_page=' + data.page : '';
  const sortField = data.sortField ? '&_sortField=' + data.sortField : '';
  const sortDirection = data.sortDirection ? '&_sortDir=' + data.sortDirection : '';


  // console.log('page', page)
  // console.log('sortField', sortField)
  // console.log('sortDirection', sortField)
  // if (sortField && sortDirection) {
  //   page += '&_solfField=' + sortField + '&_sortDirection=' + sortDirection;
  // }
  // console.log('aaaxxx')

  const response = await Api.apiGet('users', page + sortField + sortDirection);
  // const response = await Api.apiGet('users', 1);
  console.log('aaaxxx', response)
  return { data: response.data, totalRows: response.headers['x-paging-total-rows'] };
});

export const saveUsers = createAsyncThunk('users/save', async (data) => {
  const response = await Api.apiPost('users', data);
  // const response = await post('users', data);
  if (data.id) {
    return data;
  } else {
    return response;
  }
});

export const changePassword = createAsyncThunk('users/changePassword', async (data) => {
  const response = await Api.apiPost('users/changePassword', data);
  if (response && response.response && response.response.status === 400) {
    return { success: false, message: response.response.data.message || 'Password change failed.' };
  }
  toast.success('Password changed successfully!');
  return { success: true };
});

// export const deleteUsers = createAsyncThunk('users/delete', async (data) => {
//   // const response = await delete('users', data);
//   // console.log(response)
//   // return response;
// });
export const deleteUser = createAsyncThunk('users/delete', async ({id, index}) => {
  const response = await Api.apiDelete('users/' + id);
  return {id, index};
});

export const deleteUsers = createAsyncThunk('users/bulkDelete', async ({ids, index}) => {
  const response = await Api.apiPost('users/bulkDelete', ids);
  return {ids, index};
});



// export const userSlice = createSlice({
//     name: 'header',
//     initialState: {
//       isLoading: false,
//       users : []
//   },

//     // initialState: {
//     //     pageTitle: "Home",  // current page title state management
//     //     noOfNotifications : 15,  // no of unread notifications
//     //     newNotificationMessage : "",  // message of notification to be shown
//     //     newNotificationStatus : 1,   // to check the notification type -  success/ error/ info
//     // },
//     reducers: {
//         setPageTitle: (state, action) => {
//             state.pageTitle = action.payload.title
//         },


//         // removeNotificationMessage: (state, action) => {
//         //     state.newNotificationMessage = ""
//         // },

//         // showNotification: (state, action) => {
//         //     state.newNotificationMessage = action.payload.message
//         //     state.newNotificationStatus = action.payload.status
//         // },
//     },

//     extraReducers: {
//       [getUsers.pending]: state => {
//         state.isLoading = true
//       },
//       [getUsers.fulfilled]: (state, action) => {
//         state.users = action.payload.data
//         state.isLoading = false
//       },
//       [getUsers.rejected]: state => {
//         state.isLoading = false
//       },
//       }
// })

export const userSlice = createSlice({
  name: 'users',
  initialState: {
    isLoading: false,
    users: [],
    totalRows: 0
  },
  reducers: {
    addNewUser: (state, action) => {
      let {newLeadObj} = action.payload
      console.log(newLeadObj)
    },
  },

  extraReducers: {
    [getUsers.pending]: state => {
      state.isLoading = true
    },
    [getUsers.fulfilled]: (state, action) => {
      console.log(action.payload)
      state.users = action.payload.data;
      state.totalRows = action.payload.totalRows;
      state.isLoading = false;
    },
    [getUsers.rejected]: state => {
      state.isLoading = false
    },

    [saveUsers.pending]: state => {
      state.isLoading = true
    },
    [saveUsers.fulfilled]: (state, action) => {
      if (!action.payload.id) {
        state.users.push(action.payload);
      } else {
        for (let k in state.users) {
          if (state.users[k].id == action.payload.id) {
            state.users[k] = action.payload;
            break;
          }
        }
      }
      state.isLoading = false
    },
    [saveUsers.rejected]: state => {
      state.isLoading = false
    },

    [deleteUser.pending]: state => {
      state.isLoading = true
    },
    [deleteUser.fulfilled]: (state, action) => {
      let {index} = action.payload
      state.users.splice(index, 1)
    },
    [deleteUser.rejected]: state => {
      state.isLoading = false
    },
  }
})

// export const { setPageTitle } = userSlice.actions

// export default userSlice.reducer
export const { addNewUser } = userSlice.actions

export default userSlice.reducer